import React, { Component } from 'react';

export class Timer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { inComingCallDuration } = this.props;
    return (
      <div style={{ display: 'flex' }}>
        <i style={{ marginRight: 10, marginLeft: 10 , cursor:'pointer' }} className="material-icons"onClick={this.props.onStartCall}>phone</i>
        <span style={{ fontSize: '1.2em' }}>{ inComingCallDuration }</span>
      </div>
    );
  }
}